(() => {
  const mobile = window.matchMedia('(max-width: 800px)');

  function scrollToCurrentWizardPanel(root) {
    if (!root || !mobile.matches) return;
    window.requestAnimationFrame(() => {
      const target = root.querySelector('[data-kzw-result]:not([hidden])') || root.querySelector('[data-kzw-step]:not([hidden])');
      if (!target) return;
      const header = document.querySelector('.kzh');
      const offset = (header ? header.offsetHeight : 0) + 12;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  function replaceHomepageClaims() {
    const proof = document.querySelectorAll('.kz-hero__proof span');
    if (proof.length >= 3) {
      proof[0].textContent = 'Doświadczenie od 2011';
      proof[1].textContent = 'Serwis i części w Polsce';
      proof[2].textContent = 'Pomoc w doborze';
    }

    const specs = document.querySelectorAll('.kz-specbar__inner > span');
    if (specs.length >= 5) {
      const label = specs[4].querySelector('small');
      const value = specs[4].querySelector('b');
      if (label) label.textContent = 'Rozruch';
      if (value) value.textContent = 'Ręczny / elektryczny';
    }

    const trust = document.querySelectorAll('.kz-trust__item');
    if (trust.length >= 3) {
      const trust2Title = trust[1].querySelector('b');
      const trust2Text = trust[1].querySelector('small');
      const trust3Title = trust[2].querySelector('b');
      const trust3Text = trust[2].querySelector('small');
      if (trust2Title) trust2Title.textContent = 'Dobór do zastosowania';
      if (trust2Text) trust2Text.textContent = 'Moc, napięcie i sposób rozruchu';
      if (trust3Title) trust3Title.textContent = 'Dane techniczne podane wprost';
      if (trust3Text) trust3Text.textContent = 'Moc nominalna i maksymalna';
    }
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-kzw-next], [data-kzw-back], [data-kzw-restart]');
    if (!control) return;
    const root = control.closest('[data-kzw]');
    if (!root) return;
    window.setTimeout(() => scrollToCurrentWizardPanel(root), 40);
  });

  replaceHomepageClaims();
})();